import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'cw-loader-inline',
    template: `
        <img src="/assets/base/img/loader.gif" class="cw-loader__image" alt="loader"/>
    `,
    styleUrls: [
        './loader.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CwLoaderInlineComponent {
    @HostBinding('class.mini')
    @Input()
    public bindHostClass = true;

    @HostBinding('class.cw-loader--global')
    @Input()
    public global = false;
}
